import React, { Component } from 'react'

import { css } from '@emotion/core'
import RejectionModal from './RejectionModal'

// Another way to import. This is recommended to reduce bundle size
import DotLoader from 'react-spinners/ClipLoader'

export class Modals extends Component {
  render () {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `

    const rejectContent = ''
    let returnContent = ''
    let approveContent = ''
    let transmitContent = ''
    let reviewContent = ''
    let onHoldContent = ''
    let endorseToCeaContent = ''
    let approvedByCEAContent = ''
    let endorseToPresidentContent = ''
    let approvedByPresidentContent = ''

    if (this.props.onHoldRequest === true) {
      onHoldContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>On Hold</h4>
          <form action=''>
            <div className='returnLabel'>
              <p>Message:</p>
              <small id='returnValidation' />
            </div>
            <textarea
              name='reason'
              id='returnMessage'
              onChange={this.props.handleChangeState}
            />
            <div className='modalBtnContainer'>
              <button
                type='button'
                className='cancelModalBtn'
                onClick={this.props.closeReturnModal}
              >
                CANCEL
              </button>
              <button
                type='button'
                className='returnBtnDept'
                onClick={this.props.handleOnHold}
              >
                CONFIRM
              </button>
            </div>
          </form>
        </div>
      )
    }

    if (this.props.endorseRequest === true) {
      reviewContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>In Process</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as In Process. Please confirm.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              // href={this.props.crfLink}
              className='returnBtnDept'
              onClick={this.props.handleInprocess}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.reviewRequest === true) {
      reviewContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Mark as Reviewed</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as reviewed which means that
              you will become liable in the process flow.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              type='button'
              className='returnBtnDept'
              onClick={this.props.handleReviewed}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.transmitRequest === true) {
      transmitContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Mark as Transmitted</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as transmitted which means that
              you will become liable in the process flow. Please make sure that
              you already have the hard copy of the documents to be reviewed.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              type='button'
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              type='button'
              className='returnBtnDept'
              onClick={this.props.handleTransmitted}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.rejectRequest === true) {
      returnContent = (
        <div className='modalContent'>
          <RejectionModal
            confirmLabel='Reject'
            confirmAction={this.props.handleRejectRequest}
            cancelAction={this.props.closeReturnModal}
            headerLabel='REJECT THIS REQUEST'
          />
        </div>
      )
    }

    if (this.props.returnRequest === true) {
      returnContent = (
        <div className='modalContent'>
          <RejectionModal
            confirmLabel='Confirm'
            confirmAction={this.props.handleReturnRequest}
            cancelAction={this.props.closeReturnModal}
            headerLabel='RETURNING A REQUEST'
          />
        </div>
      )
    }

    if (this.props.endorseToCeaRequest === true) {  
      endorseToCeaContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Endorse Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to endorse this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleEndorseToCea}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.approvedByCEARequest === true) {
      approvedByCEAContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleApprovedByCEA}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.endorseToPresidentRequest === true) {
      endorseToPresidentContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Endorse Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to endorse this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleEndorseToPresident}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.approvedByPresidentRequest === true) {
      approvedByPresidentContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleApprovedByPresident}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.approveRequest === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleApproveCrf}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.editCrfDetails === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>edit Details Request</h4>
        </div>
      )
    }

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg' onClick={this.props.closeReturnModal} />
          {returnContent}
          {approveContent}
          {endorseToCeaContent}
          {approvedByCEAContent}
          {endorseToPresidentContent}
          {approvedByPresidentContent}
          {rejectContent}
          {transmitContent}
          {reviewContent}
          {onHoldContent}
        </div>
      </div>
    )
  }
}

export default Modals
